module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-3 ma-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-space-between": "",
      "pb-3": ""
    }
  }, [_c('h2', [_vm._v("Mass remove")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "fab": "",
      "small": "",
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.err) ? _c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.err) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-start": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-2": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Remove type",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "value",
      "hide-details": ""
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs7": "",
      "px-2": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.type === 'taxCategory') ? _c('v-combobox', {
    attrs: {
      "label": _vm.label,
      "items": _vm.taxCategories
    },
    nativeOn: {
      "input": function($event) {
        return (function (e) { return _vm.taxCategory = e.target.value; })($event)
      }
    },
    model: {
      value: (_vm.taxCategory),
      callback: function($$v) {
        _vm.taxCategory = $$v
      },
      expression: "taxCategory"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.type === 'vatRate') ? _c('v-select', {
    staticClass: "pt-2",
    attrs: {
      "items": _vm.vatItems,
      "disabled": !this.selectedCompanyInfo.vatRates || this.selectedCompanyInfo.vatRates.length === 0 ? true : false
    },
    model: {
      value: (_vm.vatRate),
      callback: function($$v) {
        _vm.vatRate = $$v
      },
      expression: "vatRate"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "py-4": "",
      "px-2": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'views') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.viewsClone), function(view, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": view.name[_vm.language]
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (view.selected),
        callback: function($$v) {
          _vm.$set(view, "selected", $$v)
        },
        expression: "view.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'printerCategories') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.catalogPrinters), function(printer, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": printer.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (printer.selected),
        callback: function($$v) {
          _vm.$set(printer, "selected", $$v)
        },
        expression: "printer.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'settings') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, _vm._l((_vm.settings), function(setting, index) {
    return _c('v-checkbox', {
      key: index,
      attrs: {
        "color": "primary",
        "label": setting.name
      },
      on: {
        "change": function($event) {
          return _vm.$forceUpdate()
        }
      },
      model: {
        value: (setting.selected),
        callback: function($$v) {
          _vm.$set(setting, "selected", $$v)
        },
        expression: "setting.selected"
      }
    })
  }), 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'sizes') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.en),
      callback: function($$v) {
        _vm.$set(_vm.size, "en", $$v)
      },
      expression: "size.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.de),
      callback: function($$v) {
        _vm.$set(_vm.size, "de", $$v)
      },
      expression: "size.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.zh),
      callback: function($$v) {
        _vm.$set(_vm.size, "zh", $$v)
      },
      expression: "size.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.price),
      callback: function($$v) {
        _vm.$set(_vm.size, "price", $$v)
      },
      expression: "size.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.size.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.size, "isDefault", $$v)
      },
      expression: "size.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'variants') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.en),
      callback: function($$v) {
        _vm.$set(_vm.variant, "en", $$v)
      },
      expression: "variant.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.de),
      callback: function($$v) {
        _vm.$set(_vm.variant, "de", $$v)
      },
      expression: "variant.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.zh),
      callback: function($$v) {
        _vm.$set(_vm.variant, "zh", $$v)
      },
      expression: "variant.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.price),
      callback: function($$v) {
        _vm.$set(_vm.variant, "price", $$v)
      },
      expression: "variant.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.variant.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.variant, "isDefault", $$v)
      },
      expression: "variant.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'options') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.en),
      callback: function($$v) {
        _vm.$set(_vm.option, "en", $$v)
      },
      expression: "option.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.de),
      callback: function($$v) {
        _vm.$set(_vm.option, "de", $$v)
      },
      expression: "option.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.zh),
      callback: function($$v) {
        _vm.$set(_vm.option, "zh", $$v)
      },
      expression: "option.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Price"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.price),
      callback: function($$v) {
        _vm.$set(_vm.option, "price", $$v)
      },
      expression: "option.price"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.option.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.option, "isDefault", $$v)
      },
      expression: "option.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.type === 'styles') ? _c('div', [_c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "EN Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.en),
      callback: function($$v) {
        _vm.$set(_vm.style, "en", $$v)
      },
      expression: "style.en"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "DE Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.de),
      callback: function($$v) {
        _vm.$set(_vm.style, "de", $$v)
      },
      expression: "style.de"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ZH Name"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.zh),
      callback: function($$v) {
        _vm.$set(_vm.style, "zh", $$v)
      },
      expression: "style.zh"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "wrap": "",
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": "",
      "px-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "color": "primary",
      "label": "Set as Default"
    },
    on: {
      "change": function($event) {
        return _vm.$forceUpdate()
      }
    },
    model: {
      value: (_vm.style.isDefault),
      callback: function($$v) {
        _vm.$set(_vm.style, "isDefault", $$v)
      },
      expression: "style.isDefault"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-end": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitMassRemove()
      }
    }
  }, [_vm._v("Submit")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20cfca5b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/MassRemoveModal.vue
// module id = 572
// module chunks = 18